import { ContingencyStatus } from '../../types/dte/contingency/ContingencyEventTable';

export const contingencySteps: Array<{ status: ContingencyStatus; label: string }> = [
  { status: 'STARTED', label: 'Contingencia iniciada' },
  { status: 'GENERATING_DTE', label: 'Generando documentos en contingencia' },
  { status: 'EVENT_TRANSMITTED', label: 'Evento enviado a Hacienda' },
  { status: 'DTE_TRANSMITTING', label: 'Enviando lote de documentos' },
  { status: 'CHECKING_RECEPTION', label: 'Consultando resultado del lote' },
  { status: 'FINISHED', label: 'Evento finalizado' },
];

export const reachedContingencyStep = (current: string, step: string) => {
  const currentIndex = contingencySteps.findIndex((item) => item.status === current);
  const stepIndex = contingencySteps.findIndex((item) => item.status === step);
  return currentIndex >= 0 && stepIndex <= currentIndex;
};

export const safeParseJson = <T,>(raw?: string | null): T | null => {
  if (!raw) return null;
  try { return JSON.parse(raw) as T; } catch { return null; }
};
